// extracted by mini-css-extract-plugin
module.exports = {"root":"TabNav_root__2fP-y","tab":"TabNav_tab__3qBCx","link":"TabNav_link__H50lm","selectedLink":"TabNav_selectedLink__2cz3L","disabled":"TabNav_disabled__25j-3"};